module.exports = __webpack_public_path__ + "static/media/encryption_ssl_logo.25a4a9df.svg";